import React, { useEffect, useRef, useState } from "react";
import TableBody from "@mui/material/TableBody";
// import axios from "../../config/axios";
import { useNavigate } from "react-router-dom";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import Search from "../../shared/Search";
import { CustomIconButton } from "../../shared/CustomIconButton";
import { toast } from "react-toastify";
import { Active, Inactive } from "../../shared/ActivaInactive";
import AddStore from "./AddStore";
import Loader from "../../shared/Loader";
import { Divider, MenuItem, Select, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Popup from "reactjs-popup";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";

// start
import "react-quill/dist/quill.snow.css";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// QR Code start
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Switch from "@mui/material/Switch";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import ReactQuill from "react-quill";
import { useFormik } from "formik";
import axiosInstance from "../../config/axios";

const style = {
  position: "absolute",
  top: "5%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const Store = () => {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [page, setPage] = useState(1);
  const superuserId = localStorage.getItem("is_superuser");
  const [businessData, setBusinessData] = useState([]);
  const [subBusinessData, setSubBusinessData] = useState([]);
  const [businessId, setBusinessId] = useState("");
  //add store
  // update start
  const [store_name, setstore_name] = useState("");
  const [store_number, setstore_number] = useState("");
  const [meta_description, setMeta_description] = useState("");
  const [meta_title, setMeta_title] = useState("");
  const [return_and_refund_policy, setreturn_and_refund_policy] = useState("");
  const [email, setemail] = useState("");
  const [image, setImage] = useState("");
  const [logo, setLogo] = useState("");
  const [about_us, setabout_us] = useState("");
  const [shipping_policy, setshipping_policy] = useState("");
  const [meta_keyword, setMeta_keyword] = useState("");
  const [other_policy, setother_policy] = useState("");
  const [contact_us, setcontact_us] = useState("");
  const [active_status, setStoreActive] = useState("");
  const [returnRefundActive, setReturnRefundActive] = useState("");
  const [replacementActive, setReplacementActive] = useState("");
  const storeId = localStorage.getItem("store_id");
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPage, setTotalPage] = useState(null);

  const [googleAnalysics, setGoogleAnalysics] = useState("");
  const [googleMap, setGoogleMap] = useState("");
  const [googleFacebook, setGoogleFacebook] = useState("");
  const [google, setGoogle] = useState("");

  // new field add start
  const [faviconeIcon, setFaviconeIcon] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pincode, setPincode] = useState("");

  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [pincodeData, setPincodeData] = useState([]);
  const [countryId, setCountryId] = useState("");
  const [stateId, setStateId] = useState("");
  const [cityId, setCityId] = useState("");

  const [googleMapKey, setGoogleMapKey] = useState("");
  const [googleKey, setGoogleKey] = useState("");
  const [googleSecret, setGoogleSecret] = useState("");
  const [facebookKey, setFacebookKey] = useState("");
  const [facebookSecret, setFacebookSecret] = useState("");
  const [trackingKey, setTrackingKey] = useState("");
  const [baseUrl, setBaseUrl] = useState("");
  const [subscriptionEnableAdmin, setSubscriptionEnableAdmin] = useState("");
  // new field add end

  // update end
  console.log("logo==>", logo);
  // super admin side update start
  const [subBusinessId, setSubBusinessId] = useState("");
  const [ids, setIds] = useState("");
  const [rowData, setRowData] = useState({});
  // super admin side update end

  const box1 = useRef();

  const previousData = () => {
    setPage(page - 1);
  };
  const nextData = () => {
    setPage(page + 1);
  };

  const closeModal = () => {
    // box1.current.style.display="none"
    box1.current.style.display = "none";
  };

  const handleChange = (event) => {
    event.is_store_active_status == true
      ? axiosInstance
          .post(
            `store-data-deactivate/`,
            { store_id: event?.id },
            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            },
          )
          .then((response) => {
            console.log("succes");
            storeApi(); // toast.success(response.data.message);
          })
          .catch((error) => {
            console.log("", error.response);
            console.log(error);
            // alert(error.message);
          })
      : axiosInstance
          .post(
            `store-data-activate/`,
            { store_id: event?.id },
            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            },
          )
          .then((response) => {
            console.log("succes");
            storeApi(); // toast.success(response.data.message);
          })
          .catch((error) => {
            console.log("", error.response);
            console.log(error);
            // alert(error.message);
          });
  };

  const storeApi = () => {
    const storeId = localStorage.getItem("store_id");
    const superuserId = localStorage.getItem("is_superuser");

    {
      superuserId === "true"
        ? axiosInstance
            .get(`api/admin/multivendor-show-store-list/`, {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            })
            .then((response) => {
              setData(response?.data?.vendor_store_list);
              console.log(
                "store data list==>",
                response?.data?.vendor_store_list,
              );
              setCurrentPage(response?.data?.current_page);
              setTotalPage(response?.data?.total_pages);
            })
            .catch((error) => {
              console.log("", error.response);
              console.log(error);
              toast.error(error.message);
            })
        : axiosInstance
            .get(`api/admin/multivendor-show-store-details/`, {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            })
            .then((response) => {
              setData(response?.data?.vendor_store_list);
              console.log(
                "normal admin owner ===>",
                response?.data?.vendor_store_list,
              );
            })
            .catch((error) => {
              console.log("", error.response);
              console.log(error);
              toast.error(error.message);
            });
    }
  };

  useEffect(() => {
    storeApi();
  }, [page, searchQuery]);

  const EditFunction = (event, row) => {
    event.preventDefault();
    console.log("row data===>", row);
    setstore_name(row?.store_name);
    setstore_number(row?.store_number);
    setemail(row?.email);
    setMeta_description(row?.Meta_Description);
    setMeta_keyword(row?.Meta_Keyword);
    setreturn_and_refund_policy(
      row?.is_return_and_refund_policy_active ? "True" : "False",
    );
    setReplacementActive(row?.is_replacement_policy_active ? "True" : "False");
    setMeta_title(row?.Meta_Title);
    setGoogleAnalysics(row?.is_active_google_analytics ? "True" : "False");
    setGoogleMap(row?.is_active_google_map ? "True" : "False");
    setGoogleFacebook(row?.is_active_login_with_facebook ? "True" : "False");
    setGoogle(row?.is_active_login_with_google ? "True" : "False");
    setRowData(row);
    setBusinessId(row?.business_type?.business_type?.id);
    setSubBusinessId(row?.business_type?.id);
    setIds(row?.id);
    setCountry(row?.country);
    setState(row?.state);
    setCity(row?.city);
    setPincode(row?.pincode);
    handleOpen();
  };

  const dandleSubmit = () => {
    const reqBody = new FormData();
    reqBody.append("store_name", store_name);
    reqBody.append("store_number", store_number);
    reqBody.append("meta_description", meta_description);
    reqBody.append("meta_title", meta_title);
    reqBody.append("return_and_refund_policy", return_and_refund_policy);
    reqBody.append("email", email);
    reqBody.append("store_image", image);
    reqBody.append("store_logo", logo);
    reqBody.append("about_us", about_us);
    reqBody.append("shipping_policy", shipping_policy);
    reqBody.append("meta_keyword", meta_keyword);
    reqBody.append("other_policy", other_policy);
    reqBody.append("contact_us", contact_us);
    reqBody.append("active_status", active_status ? "True" : "False");
    reqBody.append(
      "is_return_and_refund_policy_active",
      returnRefundActive ? "True" : "False",
    );
    reqBody.append(
      "is_replacement_policy_active",
      replacementActive ? "True" : "False",
    );
    reqBody.append("is_active_google_analytics", googleAnalysics);
    reqBody.append("is_active_google_map", googleMap);
    reqBody.append("is_active_login_with_facebook", googleFacebook);
    reqBody.append("is_active_login_with_google", google);
    reqBody.append(
      "business_type_id",
      subBusinessId || rowData?.business_type?.id,
    );
    reqBody.append("store_favicon", faviconeIcon);
    reqBody.append("country", country || rowData?.country);
    reqBody.append("state", state || rowData?.state);
    reqBody.append("city", city || rowData?.city);
    reqBody.append("pincode", pincode);
    reqBody.append("store_id", ids);

    reqBody.append("google_map_key", googleMapKey);
    reqBody.append("google_key ", googleKey);
    reqBody.append("google_secret", googleSecret);
    reqBody.append("facebook_key", facebookKey);
    reqBody.append("facebook_secret", facebookSecret);
    reqBody.append("google_analytics_tracking_key", trackingKey);
    reqBody.append("base_url", baseUrl);

    axiosInstance
      .post(`api/admin/multivendor-show-store-details/`, reqBody, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        toast.success(response.data.message);
        storeApi();
        handleClose();
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };

  const closePopup = (event) => {
    event.preventDefault();
    handleClose2();
    handleClose2();
    storeApi();
  };
  console.log("open2", open2);

  const formik = useFormik({
    initialValues: {
      store_name: "",
      business_type_id: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      pin_code: "",
      first_name: "",
      last_name: "",
      mobile_no: "",
      email: "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      const reqBody = new FormData();
      reqBody.append("store_name", values.store_name);
      reqBody.append("business_type_id", values.business_type_id);
      reqBody.append("address", values.address);
      reqBody.append("address2", values.address2);
      reqBody.append("city", values.city);
      reqBody.append("state", values.state);
      reqBody.append("country", values.country);
      reqBody.append("pin_code", values.pin_code);
      reqBody.append("first_name", values.first_name);
      reqBody.append("last_name", values.last_name);
      reqBody.append("mobile_no", values.mobile_no);
      reqBody.append("email", values.email);

      axiosInstance
        .post(`api/admin/vendor-registration-form/`, reqBody, {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        })
        .then((response) => {
          toast.success(response.data.message);
          values.store_name("");
          handleClose1();
        })
        .catch((error) => {
          console.log("error page", error.response);
          console.log(error);
        });
    },
  });

  const businessDataList = () => {
    axiosInstance
      .post(
        `api/admin/multivendor-business-category-list-data/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setBusinessData(response.data.business_category_list_data);
        console.log(
          "business data list ==>",
          response.data?.business_category_list_data,
        );
      })
      .catch((error) => {
        console.log("business page", error.response);
        console.log(error);
      });
  };

  useEffect(() => {
    businessDataList();
  }, []);
  // rowData?.business_type
  const subBusinessDataList = () => {
    axiosInstance
      .post(
        `api/admin/multivendor-business-sub-category-list-data/`,
        { business_category_ids: businessId },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setSubBusinessData(response.data.business_sub_category_list);
        console.log(
          "sub business data list ==>",
          response.data?.business_sub_category_list,
        );
      })
      .catch((error) => {
        console.log("sub business page", error.response);
        console.log(error);
      });
  };

  useEffect(() => {
    subBusinessDataList();
  }, [businessId]);

  // start country,state,city,pincode wise data list start
  const countryDataList = () => {
    axiosInstance
      .get(`api/country-list/`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("country list data===>", response?.data?.data);
        setCountryData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    countryDataList();
  }, []);

  const stateList = () => {
    axiosInstance
      .post(
        `api/state-list/`,
        { country_id: countryId || rowData?.country },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        console.log("country list data===>", response?.data?.data);
        setStateData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    countryId && stateList();
    rowData?.country && stateList();
  }, [countryId, rowData?.country]);

  const cityDataList = () => {
    axiosInstance
      .post(
        `api/city-list/`,
        { state_id: stateId || rowData?.state },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        console.log("country list data===>", response?.data?.data);
        setCityData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    stateId && cityDataList();
    rowData?.state && cityDataList();
  }, [stateId, rowData?.state]);

  const cityBasedPincodeDataList = () => {
    axiosInstance
      .post(
        `api/get-city-based-pincode-data/`,
        { city_id: cityId || rowData?.city },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        console.log("city based list data===>", response?.data?.data);
        setPincodeData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    cityId && cityBasedPincodeDataList();
    rowData?.city && cityBasedPincodeDataList();
  }, [cityId, rowData?.city]);
  // start country,state,city,pincode wise data list end

  const countryDataFind = (elem) => {
    console.log("datalist", elem);
    setCountryId(elem.id);
    setCountry(elem?.country);
  };

  const stateDataFind = (elem) => {
    console.log("datalist", elem);
    setStateId(elem.id);
    setState(elem?.state);
  };
  const cityDataFind = (elem) => {
    setCityId(elem.id);
    setCity(elem?.state);
  };
  return (
    <>
      <div className="!bg-white">
        <div className="flex justify-between !bg-slate-100">
          <div className="flex gap-96 p-2">
            <p className="text-xl font font-bold !text-black">
              My Store Details
            </p>
          </div>
          <div className="p-2 pt-5  ">
            {superuserId === "true" ? (
              <Button
                className=""
                size="small"
                variant="outlined"
                onClick={handleOpen1}
              >
                + Add New Store
              </Button>
            ) : null}

            <Modal
              open={open1}
              onClose={handleClose1}
              aria-labelledby="child-modal-title"
              aria-describedby="child-modal-description"
            >
              <Box
                sx={{ ...style1, width: 900 }}
                className="rounded-2xl !border-0 !h-[80vh] overflow-auto"
              >
                <div
                  id="child-modal-title "
                  className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                >
                  Add New Store
                </div>
                <form onSubmit={formik.handleSubmit}>
                  <div>
                    <div>Select Business Type</div>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="!w-[100%] !mt-1"
                        size="small"
                        onChange={(event) => setBusinessId(event.target.value)}
                      >
                        {businessData.map((elem) => (
                          <MenuItem value={elem?.id}>{elem?.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="flex justify-between w-full">
                    <div className="w-[48%]">
                      <div className="mt-2">Select Sub Business Type</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="business_type_id"
                          className="!w-[100%] !mt-1"
                          size="small"
                          onChange={formik.handleChange}
                          value={formik.values.business_type_id}
                        >
                          {subBusinessData?.map((elem) => (
                            <MenuItem value={elem?.id}>{elem?.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <div className="mt-2">First Name</div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                        name="first_name"
                        onChange={formik.handleChange}
                        value={formik.values.first_name}
                      />
                      <div className="mt-2">Email</div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                        name="email"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                      />
                      <div className="mt-2">Address</div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                        name="address"
                        onChange={formik.handleChange}
                        value={formik.values.address}
                      />
                      <div className="mt-2">Pin Code</div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                        name="pin_code"
                        onChange={formik.handleChange}
                        value={formik.values.pin_code}
                      />
                      <div className="mt-2">State</div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                        name="state"
                        onChange={formik.handleChange}
                        value={formik.values.state}
                      />
                    </div>
                    <div className="w-[48%]">
                      <div className="mt-2">Store Name</div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                        name="store_name"
                        onChange={formik.handleChange}
                        value={formik.values.store_name}
                      />
                      <div className="mt-2">Last Name</div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                        name="last_name"
                        onChange={formik.handleChange}
                        value={formik.values.last_name}
                      />
                      <div className="mt-2">Mobile Number</div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        type="number"
                        minlength="10"
                        maxlength="10"
                        pattern="[6789][0-9]{9}"
                        className="!w-[100%] !mt-1"
                        name="mobile_no"
                        onChange={formik.handleChange}
                        value={formik.values.mobile_no}
                      />
                      <div className="mt-2">Second Address</div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                        name="address2"
                        onChange={formik.handleChange}
                        value={formik.values.address2}
                      />
                      <div className="mt-2">City</div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                        name="city"
                        onChange={formik.handleChange}
                        value={formik.values.city}
                      />
                      <div className="mt-2">Country</div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                        name="country"
                        onChange={formik.handleChange}
                        value={formik.values.country}
                      />
                    </div>
                  </div>
                  <Button
                    onClick={handleClose1}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    type="submit"
                    className="!py-2 !px-8 !mt-3 bg-yellow-300 !float-right"
                  >
                    ADD
                  </Button>
                </form>
              </Box>
            </Modal>
          </div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
            // className="overflow-x-scroll "
          >
            <Box
              sx={{ ...style, width: 900, height: 500 }}
              className="rounded-2xl !border-0 !mt-64 overflow-auto"
            >
              <div
                id="child-modal-title "
                className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                // onClick={handleOpenModal}
              >
                Store Update
              </div>
              {superuserId === "true" ? (
                <div>
                  <div>Select Business Type</div>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      className="!w-[100%] !mt-1"
                      size="small"
                      value={
                        businessId ||
                        rowData?.business_type?.business_type?.id ||
                        ""
                      }
                      onChange={(event) => setBusinessId(event.target.value)}
                    >
                      {businessData.map((elem) => (
                        <MenuItem value={elem?.id}>{elem?.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <div className="mt-2">Select Sub Business Type</div>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="business_type_id"
                      className="!w-[100%] !mt-1"
                      size="small"
                      value={subBusinessId || rowData?.business_type?.id || ""}
                      onChange={(event) => setSubBusinessId(event.target.value)}
                    >
                      {subBusinessData?.map((elem) => (
                        <MenuItem value={elem?.id}>{elem?.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              ) : null}
              <div className="flex justify-between">
                <div className="w-[48%]">
                  <div>Store Name</div>
                  <TextField
                    size="small"
                    value={store_name}
                    onChange={(event) => setstore_name(event.target.value)}
                    id="outlined-basic"
                    placeholder="Enter Store Name"
                    className="!w-[100%] !mt-1"
                  />
                  <div className="mt-2">Email</div>
                  <TextField
                    value={email}
                    onChange={(event) => setemail(event.target.value)}
                    id="outlined-basic"
                    placeholder="Enter Your Email"
                    size="small"
                    className="!w-[100%] !mt-1"
                  />
                  <div className="mt-2">Mobile Number</div>
                  <TextField
                    value={store_number}
                    onChange={(event) => setstore_number(event.target.value)}
                    id="outlined-basic"
                    size="small"
                    className="!w-[100%] !mt-1"
                  />
                  <div className="mt-2">Select Country :</div>
                  <FormControl fullWidth>
                    <Select
                      size="small"
                      className="mt-1"
                      value={country | rowData?.country || ""}
                      onChange={(e) => countryDataFind(e.target.value)}
                      name="productId"
                    >
                      {countryData?.map((elem) => (
                        <MenuItem value={elem}>{elem?.country}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <div className="mt-2">Select State :</div>
                  <FormControl fullWidth>
                    <Select
                      size="small"
                      className="mt-1"
                      value={state || rowData?.state || ""}
                      onChange={(e) => stateDataFind(e.target.value)}
                      name="productId"
                    >
                      {stateData?.map((elem) => (
                        <MenuItem value={elem}>{elem?.state}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <div className="mt-2">Select City :</div>
                  <FormControl fullWidth>
                    <Select
                      size="small"
                      className="mt-1"
                      value={city || rowData?.city || ""}
                      onChange={(e) => cityDataFind(e.target.value)}
                      name="productId"
                    >
                      {cityData?.map((elem) => (
                        <MenuItem value={elem}>{elem?.city}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <div className="mt-2">Select Pincode :</div>
                  <FormControl fullWidth>
                    <Select
                      size="small"
                      className="mt-1"
                      value={pincode || rowData?.pincode || ""}
                      onChange={(e) => setPincode(e.target.value)}
                      name="productId"
                    >
                      {pincodeData?.map((elem) => (
                        <MenuItem value={elem?.pincode}>
                          {elem?.city_name} ({elem?.pincode})
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl>
                    <FormLabel
                      id="demo-controlled-radio-buttons-group"
                      className="!mt-2"
                    >
                      <span className="text-gray-700"> Google Analytics :</span>
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={"" || googleAnalysics}
                      onChange={(event) =>
                        setGoogleAnalysics(event.target.value)
                      }
                    >
                      <FormControlLabel
                        value="True"
                        control={<Radio />}
                        label="True"
                      />
                      <FormControlLabel
                        value="False"
                        control={<Radio />}
                        label="False"
                      />
                    </RadioGroup>
                  </FormControl>
                  <br />
                  <FormControl>
                    <FormLabel
                      id="demo-controlled-radio-buttons-group"
                      className="!mt-2"
                    >
                      <span className="text-gray-700"> Login Google :</span>
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={"" || google}
                      onChange={(event) => setGoogle(event.target.value)}
                    >
                      <FormControlLabel
                        value="True"
                        control={<Radio />}
                        label="True"
                      />
                      <FormControlLabel
                        value="False"
                        control={<Radio />}
                        label="False"
                      />
                    </RadioGroup>
                  </FormControl>
                  {google === "True" && (
                    <>
                      <div className=""> Google Key</div>
                      <TextField
                        value={googleKey}
                        onChange={(event) => setGoogleKey(event.target.value)}
                        id="outlined-basic"
                        defaultValue="Small"
                        size="small"
                        placeholder="Enter Google Key"
                        className="!w-[100%] !mt-1"
                      />
                      <div className="mt-2"> Google Secret</div>
                      <TextField
                        value={googleSecret}
                        onChange={(event) =>
                          setGoogleSecret(event.target.value)
                        }
                        id="outlined-basic"
                        defaultValue="Small"
                        placeholder="Enter Google Secret"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                    </>
                  )}
                  <br />
                  <div className="mt-2">Meta Description</div>
                  <TextField
                    value={meta_description}
                    onChange={(event) =>
                      setMeta_description(event.target.value)
                    }
                    id="outlined-basic"
                    defaultValue="Small"
                    size="small"
                    className="!w-[100%] !mt-1"
                  />

                  <div className="mt-2">Replacement Policy Page</div>
                  <ReactQuill
                    className="w-full bg-gray-100 mt-1  text-lg font-semibold border border-gray-700"
                    value={shipping_policy}
                    onChange={setshipping_policy}
                  ></ReactQuill>
                  <div className="mt-2">Other Policy Page</div>
                  <ReactQuill
                    className="w-full bg-gray-100 mt-1 text-lg font-semibold border border-gray-700"
                    value={other_policy}
                    onChange={setother_policy}
                  ></ReactQuill>
                  <div className="mt-2">Abouts us Page</div>
                  <ReactQuill
                    className="w-full bg-gray-100 mt-1 text-lg font-semibold border border-gray-700"
                    value={about_us}
                    // value={content}
                    // setabout_us
                    onChange={setabout_us}
                  ></ReactQuill>
                </div>
                <div className="w-[48%]">
                  <div className="">Store Image</div>
                  <TextField
                    onChange={(event) => setImage(event.target.files[0])}
                    id="outlined-basic"
                    type="file"
                    size="small"
                    className="!w-[100%] !mt-1"
                  />
                  <div className="mt-2">Logo Image</div>
                  <TextField
                    onChange={(event) => setLogo(event.target.files[0])}
                    id="outlined-basic"
                    type="file"
                    size="small"
                    className="!w-[100%] !mt-1"
                  />
                  <div className="mt-2">Favicone Icon</div>
                  <TextField
                    onChange={(event) => setFaviconeIcon(event.target.files[0])}
                    id="outlined-basic"
                    type="file"
                    size="small"
                    className="!w-[100%] !mt-1"
                  />

                  <div className="mt-2">Title</div>
                  <TextField
                    value={meta_title}
                    onChange={(event) => setMeta_title(event.target.value)}
                    id="outlined-basic"
                    size="small"
                    className="!w-[100%] !mt-1"
                  />
                  <div className="mt-2"> Meta Keyword</div>
                  <TextField
                    value={meta_keyword}
                    onChange={(event) => setMeta_keyword(event.target.value)}
                    id="outlined-basic"
                    defaultValue="Small"
                    size="small"
                    className="!w-[100%] !mt-1"
                  />
                  <div className="mt-2"> Google Analytics Tracking Key</div>
                  <TextField
                    value={trackingKey || ""}
                    onChange={(event) => setTrackingKey(event.target.value)}
                    id="outlined-basic"
                    defaultValue="Small"
                    size="small"
                    placeholder="Enter Google Analytics Tracking key"
                    className="!w-[100%] !mt-1"
                  />
                  <div className="mt-2"> Base Url</div>
                  <TextField
                    value={baseUrl || ""}
                    onChange={(event) => setBaseUrl(event.target.value)}
                    id="outlined-basic"
                    defaultValue="Small"
                    placeholder="Enter Base URL"
                    size="small"
                    className="!w-[100%] !mt-1"
                  />
                  <FormControl>
                    <FormLabel
                      id="demo-controlled-radio-buttons-group"
                      className="!mt-2"
                    >
                      <span className="text-gray-700 !mt-3">
                        {" "}
                        Return And Refund Policy Active :
                      </span>
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={
                        "" || rowData?.is_return_and_refund_policy_active
                          ? "True"
                          : "False"
                      }
                      onChange={(event) =>
                        setReturnRefundActive(event.target.value)
                      }
                    >
                      <FormControlLabel
                        value="True"
                        control={<Radio />}
                        label="True"
                      />
                      <FormControlLabel
                        value="False"
                        control={<Radio />}
                        label="False"
                      />
                    </RadioGroup>
                  </FormControl>
                  <br />
                  <FormControl>
                    <FormLabel
                      id="demo-controlled-radio-buttons-group"
                      className="!mt-2"
                    >
                      <span className="text-gray-700"> Login Facebook :</span>
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={"" || googleFacebook}
                      onChange={(event) =>
                        setGoogleFacebook(event.target.value)
                      }
                    >
                      <FormControlLabel
                        value="True"
                        control={<Radio />}
                        label="True"
                      />
                      <FormControlLabel
                        value="Talse"
                        control={<Radio />}
                        label="Talse"
                      />
                    </RadioGroup>
                  </FormControl>
                  {googleFacebook === "True" && (
                    <>
                      <div className=""> Facebook Key</div>
                      <TextField
                        value={facebookKey}
                        onChange={(event) => setFacebookKey(event.target.value)}
                        id="outlined-basic"
                        defaultValue="Small"
                        size="small"
                        placeholder="Enter Facebook Key"
                        className="!w-[100%] !mt-1"
                      />
                      <div className="mt-2"> Facebook Secret</div>
                      <TextField
                        value={facebookSecret}
                        onChange={(event) =>
                          setFacebookSecret(event.target.value)
                        }
                        id="outlined-basic"
                        defaultValue="Small"
                        placeholder="Enter Facebook Secret"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                    </>
                  )}
                  <br />
                  <FormControl>
                    <FormLabel
                      id="demo-controlled-radio-buttons-group"
                      className="!mt-2"
                    >
                      <span className="text-gray-700"> Active Status :</span>
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={"" || rowData?.active_status ? "True" : "False"}
                      onChange={(event) => setStoreActive(event.target.value)}
                    >
                      <FormControlLabel
                        value="True"
                        control={<Radio />}
                        label="True"
                      />
                      <FormControlLabel
                        value="False"
                        control={<Radio />}
                        label="False"
                      />
                    </RadioGroup>
                  </FormControl>
                  <br />
                  <FormControl>
                    <FormLabel
                      id="demo-controlled-radio-buttons-group"
                      className="!mt-2"
                    >
                      <span className="text-gray-700"> Google Map :</span>
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={"" || googleMap}
                      onChange={(event) => setGoogleMap(event.target.value)}
                    >
                      <FormControlLabel
                        value="True"
                        control={<Radio />}
                        label="True"
                      />
                      <FormControlLabel
                        value="False"
                        control={<Radio />}
                        label="False"
                      />
                    </RadioGroup>
                  </FormControl>
                  {googleMap === "True" && (
                    <>
                      <div className="">Google Map Key</div>
                      <TextField
                        value={googleMapKey}
                        onChange={(event) =>
                          setGoogleMapKey(event.target.value)
                        }
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                    </>
                  )}
                  <div className="mt-2">Shipping Policy Page</div>
                  <ReactQuill
                    className="w-full bg-gray-100 mt-1 text-lg font-semibold border border-gray-700"
                    value={shipping_policy}
                    onChange={setshipping_policy}
                  ></ReactQuill>
                  <div className="mt-2">Return and Refund Policy page</div>
                  <ReactQuill
                    className="w-full bg-gray-100 mt-1 text-lg font-semibold border border-gray-700"
                    value={return_and_refund_policy}
                    onChange={setreturn_and_refund_policy}
                  ></ReactQuill>
                  <div className="mt-2">Contact us Page</div>
                  <ReactQuill
                    className="w-full bg-gray-100 mt-1 text-lg font-semibold border border-gray-700"
                    value={contact_us}
                    onChange={setcontact_us}
                  ></ReactQuill>
                </div>
              </div>
              <Button
                variant="contained"
                color="warning"
                className="!py-2 !my-2"
                onClick={handleClose}
              >
                CANCEL
              </Button>
              <Button
                variant="contained"
                color="success"
                className="!py-2 !px-5 ! !font-bold !float-right !my-2"
                onClick={dandleSubmit}
              >
                UPDATE
              </Button>
            </Box>
          </Modal>
        </div>
        <div className="flex flex-col !mt-3 !rounded bg-dark border-secondary shadow-card shadow-zinc-600 m-2 ">
          <div className="flex items-center p-2 h-14 !bg-slate-100 border-zinc-600">
            <input
              type="text"
              value={searchQuery}
              className="!border-3 !border-black !w-64 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </div>
          {/* <Divider /> */}
          <div className="w-[77vw] overflow-auto ">
            <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
              <Table
                size="small"
                aria-label="a dense table"
                className=""
                stickyHeader
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="w-36">Store Qr Code</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="!w-44 text-center">STORE NAME</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="!w-44 text-center">BUSINESS TYPE</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="!w-44 text-center">BUSINESS SUB TYPE</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="!w-28 text-center">STORE Image</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      EMAIL
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="w-32">MOBILE NO.</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="w-24">LATITUDE</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="w-24">LONGITUDE</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="w-24">GOOGLE ANALYTICs</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="w-24">GOOGLE MAP</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="w-24">LOGIN WITH FACEBOOK</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="w-24">LOGIN WITH GOOGLE</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      <div className="w-24">ACTION</div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="!overflow-y-auto !vh-[100%]">
                  {data &&
                    data?.map((row) => (
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.store_qr_code_unique_no
                            ? row?.store_qr_code_unique_no
                            : "--"}
                          <Popup
                            trigger={
                              <button className="button text-white rounded">
                                <RemoveRedEyeIcon
                                  className="!text-blue-500"
                                  onClick={handleOpen2}
                                />
                              </button>
                            }
                            modal
                          >
                            <div
                              className=" text-black rounded-xl p-4"
                              style={{
                                border: "1px solid gray",
                                background:
                                  "linear-gradient(180deg, rgba(2, 0, 40, 1) 0%, rgba(1, 0, 75, 1) 49%, rgba(2, 0, 95, 1) 65%, rgba(2, 0, 120, 1) 100%)",
                              }}
                            >
                              <div className="absolute cursor-pointer right-[-9px] top-[-7px] rounded">
                                <span className="text-white bg-black rounded-2xl pb-2 p-1">
                                  <CloseIcon
                                    onClick={(event) => closePopup(event)}
                                  />
                                </span>
                              </div>
                              <div className="py-2">
                                <img
                                  src={row?.store_qr_code_image}
                                  className="!w-[250px] !h-[250px] rounded"
                                  style={{ backgroundSize: "cover" }}
                                />
                              </div>
                            </div>
                          </Popup>
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.store_name ? row?.store_name : "--"}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.business_type?.business_type?.name
                            ? row?.business_type?.business_type?.name
                            : "--"}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.business_type?.name
                            ? row?.business_type?.name
                            : "--"}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          <div className="mx-auto h-8 w-8">
                            {row?.store_image ? (
                              <img src={row?.store_image} className="h-8 w-8" />
                            ) : (
                              "--"
                            )}
                          </div>
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.email ? row?.email : "--"}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.store_number ? row?.store_number : "--"}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.latitude ? row?.latitude : "--"}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.longitude ? row?.longitude : "--"}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.is_active_google_analytics ? "yes" : "no"}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.is_active_google_map ? "yes" : "no"}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.is_active_login_with_facebook ? "yes" : "no"}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {row?.is_active_login_with_google ? "yes" : "no"}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          <EditIcon
                            className="!text-xl !cursor-pointer !text-green-600"
                            onClick={(event) => EditFunction(event, row)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </>
  );
};

export default Store;
